<template>
  <header class="header" id="header" :class="{'fill': $route.path === '/galerija'}">
    <div class="wrapper">
      <div class="navigation">
        <div class="logo-holder">
          <router-link v-if="$route.path === '/'" to="/" @click="closeNav" v-scroll-to="'#home'">
            <img class="main-logo" src="/static/images/phoenix.png" alt="">
          </router-link>
          <router-link v-if="$route.path === '/galerija'" to="/" @click="closeNav">
            <img class="main-logo" src="/static/images/phoenix.png" alt="">
          </router-link>
        </div>
        <div class="nav-list">
          <div v-if="$route.path === '/'" class="nav-item">
            <router-link to="/galerija" @click="closeNav" class="nav-link">Galerija</router-link>
          </div>
          <div v-if="$route.path === '/'" class="nav-item">
            <a @click="closeNav" class="nav-link" href="javascript:" v-scroll-to="'#history'">O nama</a>
          </div>
          <div v-if="$route.path === '/'" class="nav-item">
            <a @click="closeNav" class="nav-link" href="javascript:" v-scroll-to="'#extra'">Zanimljivosti</a>
          </div>
          <div v-if="$route.path === '/'" class="nav-item">
            <a @click="closeNav" class="nav-link" href="javascript:" v-scroll-to="'#team'">Članovi</a>
          </div>
          <div v-if="$route.path === '/'" class="nav-item">
            <a @click="closeNav" class="nav-link" href="javascript:" v-scroll-to="'#contact'">Kontakt</a>
          </div>
          <div v-if="$route.path === '/galerija'" class="nav-item">
            <router-link to="/" @click="closeNav" class="nav-link">
              Početna
            </router-link>
          </div>
          <div class="social-holder">
            <div class="nav-item">
              <a @click="closeNav" href="https://sr-rs.facebook.com/pages/category/Musician-Band/Fenix-Band-Kula-462299180617615/" target="_blank">
                <i class="nav-link fa fa-facebook-f" aria-hidden="true"></i>
              </a>
            </div>
            <div class="nav-item">
              <a @click="closeNav" href="https://www.instagram.com/fenixbend_kula/" target="_blank">
                <i class="nav-link fa fa-instagram" aria-hidden="true"></i>
              </a>
            </div>
            <div class="nav-item">
              <a @click="closeNav" href="https://www.youtube.com/channel/UCQfVaOAg_LjdWUCIEZaKxhA" target="_blank">
                <i class="nav-link fa fa-youtube-play" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    methods: {
      closeNav() {
        document.getElementById('header').classList.remove('shown');
        document.getElementById('hamburger').classList.remove('is-active');
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/AppHeader.vue